import {Stop} from '@shipwell/backend-core-sdk';

export const StopAddressCell = ({stopLocation}: {stopLocation?: Stop['location']}) => {
  if (stopLocation?.address?.city && stopLocation?.address?.state_province) {
    return (
      <>
        {stopLocation?.address?.city}, {stopLocation?.address?.state_province}
      </>
    );
  }
  if (stopLocation?.address?.latitude && stopLocation?.address?.longitude) {
    return (
      <>
        {stopLocation?.address?.latitude.toFixed(2)}, {stopLocation?.address?.longitude.toFixed(2)}
      </>
    );
  }
  return <>--</>;
};
